import React, { useState, useEffect } from 'react';
import ColumnPlot from "./Charts/ColumnPlot";
import { BarChartOutlined, LineChartOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import LinePlot from './Charts/LinePlot';

const DiseaseNutrients = (props) => {
  const [columnPlotData, setColumnPlotData] = useState([]);
  const [linePlotData, setLinePlotData] = useState([]);

  useEffect(() => {
    asyncFetch('data/diseases/diseases_values.json', setColumnPlotData);
    asyncFetch('data/diseases/diseases_year_values.json', setLinePlotData);
  }, []);

  const asyncFetch = (url, setData) => {
    fetch(url)
      .then((response) => response.json())
      .then((json) => setData(json[props.label.toLowerCase()]))
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  const tabItems = [
    {
      key: '1',
      label: <span>Nutrientes (geral) <BarChartOutlined /></span>,
      children: <ColumnPlot data={columnPlotData} xFieldLabel='Nutriente' yFieldLabel='Valor'></ColumnPlot>,
    },
    {
      key: '2',
      label: <span>Nutrientes (por ano) <LineChartOutlined /></span>,
      children: <LinePlot data={linePlotData} hasSeries={true}></LinePlot>,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      items={tabItems}></Tabs>
  );
};

export default DiseaseNutrients;
